<template>
  <div>
    <base-header class="mt-4 pb-6" type=""/>
    <b-container fluid class="mt--6">
      <div>
        <loading :active="loadingCounter > 0" color= '#007bff' :width= '128' :height= '128' loader='dots' :can-cancel="true" is-full-page/>
      </div>
      <b-row>
        <b-col lg="12">
          <div class="card-wrapper">
            <card>
              <div slot="header" class="mb-0">
                <b-row>
                  <b-col cols="8">
                      <h3>{{language_terms['QUICK_SEARCH']}}</h3>
                  </b-col>
                </b-row>
              </div>
              <b-row>
                <b-col md="5" >
                  <base-input :label="language_terms['ITEM_FROM']" v-model="filter.product_from" v-on:keyup.enter="onClickSearch()">
                  </base-input>
                </b-col>
                <b-col md="5" >
                  <base-input :label="language_terms['ITEM_TO']" v-model="filter.product_to" v-on:keyup.enter="onClickSearch()">
                  </base-input>
                </b-col>
                <b-col md="2">
                  <base-input :label="language_terms['MODE']">
                    <el-select v-model="filter.mode" filterable>
                      <el-option v-for="option in mode_options"
                                :key="option.value"
                                :label="option.label"
                                :value="option.value">
                      </el-option>
                    </el-select>
                  </base-input>
                </b-col>
                <b-col md="4" >
                  <base-input :label="language_terms['DATE_FROM']">
                    <flat-picker slot-scope="{focus, blur}"
                                @on-open="focus"
                                @on-close="blur"
                                style="background-color: white;"
                                class="form-control datepicker"
                                v-model="filter.date_from">
                    </flat-picker>
                  </base-input>
                </b-col>
                <b-col md="4">
                  <base-input :label="language_terms['DATE_TO']">
                    <flat-picker slot-scope="{focus, blur}"
                                @on-open="focus"
                                @on-close="blur"
                                style="background-color: white;"
                                class="form-control datepicker"
                                v-model="filter.date_to">
                    </flat-picker>
                  </base-input>
                </b-col>
                <b-col md="3" >
                  <base-input :label="language_terms['LOCATION']" v-model="filter.location" v-on:keyup.enter="onClickSearch()"></base-input>
                </b-col>
                <b-col cols="1" class="mt-4">
                  <base-button type="primary" @click="onClickSearch" class="mt-2"><i class="fa fa-search"></i></base-button>
                </b-col>
              </b-row>
            </card>
          </div>
        </b-col>
      </b-row>
      <b-row v-if="tableItems.length > 0">
        <b-col lg="12">
          <div class="card-wrapper">
            <card>
              <div slot="header" class="mb-0">
                <b-row>
                  <b-col cols="8">
                      <h3>Stock Movement</h3>
                  </b-col>
                </b-row>
              </div>
              <b-row class="mt--4" v-if="tableItems.length > 0">
                <b-col cols="12" class="mt-3">
                    <b-table-simple hover responsive>
                        <b-thead head-variant="light">
                            <b-th>{{language_terms['DATE']}}</b-th>
                            <b-th>{{language_terms['DOCUMENT']}}</b-th>
                            <b-th>{{language_terms['PRODUCT']}}</b-th>
                            <b-th>{{language_terms['PRODUCT_NAME']}} </b-th>
                            <b-th>{{language_terms['QTY'] + ' ' + language_terms['IN']}} </b-th>
                            <b-th>{{language_terms['QTY'] + ' ' + language_terms['OUT']}} </b-th>
                            <b-th>{{language_terms['BALANCE_QTY']}} </b-th>
                            <b-th>{{language_terms['REMARKS']}} </b-th>
                            <!-- <b-th>{{language_terms['LOCATION']}} </b-th> -->
                            <b-th></b-th>
                        </b-thead>
                        <b-tbody>
                          <tr v-for="(inventory, i) in tableItems" :key="i">
                            <td>{{inventory.date}}</td>
                            <td>{{inventory.document_remarks}}</td>
                            <td>{{inventory.product_code}}</td>
                            <td>{{inventory.product_name}}</td>
                            <td>{{inventory.qty_in}}</td>
                            <td>{{inventory.qty_out}}</td>
                            <td>{{inventory.qty_balance}}</td>
                            <td>{{inventory.reference_remarks}}</td>
                            <!-- <td>{{inventory.location_code}}</td> -->
                          </tr>
                        </b-tbody>
                    </b-table-simple>
                </b-col>
              </b-row>                            
            </card>
          </div>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>
<style>
th.VueTables__sortable {color:rgb(255,255,255);}
td.VueTables__row  {color:black}
.v-data-table /deep/ .sticky-header {position: sticky; top: var(--toolbarHeight);}
.v-data-table /deep/ .v-data-table__wrapper {overflow: unset;}
</style>

<script>
import moment from 'moment'
import { Select, Option } from 'element-ui'
import flatPicker from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';  
import { mapState } from "vuex";
import PaginatedTables from '@/views/Tables/PaginatedTables'
import axios from "axios";
import { apiRoutes } from "../../apiRoutes";
import { authHeader } from "../../global";
import Vue from 'vue'

export default {
  components:{
    Loading,
    [Select.name]: Select,
    [Option.name]: Option,
    flatPicker,
    PaginatedTables
  },
  computed:{
    ...mapState
    ({
        language_terms: state => state.languages.language_terms,
        selected_lang: state => state.languages.selected_langauge,
    }),
  },
  async mounted()
  {
    this.loadingCounter++

    if(this.id == '_new')
    {
        
    }
    else
    {
        //await this.retrieve(this.id)
    }

    this.loadingCounter--
  },

  data(){
    return{
      loadingCounter:0,
      selectedInvoice:[],
      reportOptions:{hiddenColumns:['id','customer_id','invoice_date','customer_code','Exch Rate'],filterable:false, perPage:10000, perPageValues:[],stickyHeader:true, stickyHeaderColor:'#ffffff', stickyHeaderBackground:'#292F4C',},
      report:{headers:[], rows:[]},
      rowDetailsModal:false,
      filter:{
        product_from:null,
        product_to:null,
        mode:'CODE',
        date_from: moment().format("YYYY-MM-DD"),
        date_to: moment().format("YYYY-MM-DD"),
        location:null,
      },
      tableItems:[],
      mode_options:[
        {
          label:"Product Code",
          value:"CODE"
        },
        {
          label:"Product Name",
          value:"NAME"
        },
      ],
    }
  },

  methods:{
    async onClickPrint()
    {
      this.loadingCounter++

      let payload = {document_id:this.selectedInvoice.document_id}
      await axios
      .post(apiRoutes["SIP_PRINT"], payload, authHeader())
      .then((response) => 
      {
        if (response.data.code == 1) {
          this.tableItems = response.data.data
          let url =  'https://reports.unityerp.com/esteam/sales-item-picking/' +  encodeURIComponent(localStorage.getItem('access_token')) + '/' + encodeURIComponent(this.selectedInvoice.code);
          window.open(url);            
        } 
        else 
        {
          alert('Failed');
        }

      })
      .catch((error) => {
        if (error.response) {
          Vue.notify({group: "notify", type: "error", text: error.response.data.msg, max: 5, duration: 5000, speed: 300,});
        }
      });
      this.loadingCounter--
    },

    async onClickRetrieve(bankaccount_code)
    {
      let payload = {code:bankaccount_code}
      await axios
      .post(apiRoutes["SIP_RETRIEVE"], payload, authHeader())
      .then((response) => 
      {
          if (response.data.code == 1) {
              this.form = response.data.data
          } 
          else 
          {
              alert('Failed');
          }

      })
      .catch((error) => {
          if (error.response) {
              Vue.notify({group: "notify", type: "error", text: error.response.data.msg, max: 5, duration: 5000, speed: 300,});
          }
      });
    },
    async onClickSearch()
    {
      this.loadingCounter++

      this.filter.limit = ''
      let payload = this.filter
          
      await axios
      .post(apiRoutes["INVENTORY_MOVEMENT_SEARCH"], payload, authHeader())
      .then((response) => 
      {
        if (response.data.code == 1) {
          this.tableItems = response.data.data
        } 
        else 
        {
          alert('Failed');
        }

      })
      .catch((error) => {
        if (error.response) {
          Vue.notify({group: "notify", type: "error", text: error.response.data.msg, max: 5, duration: 5000, speed: 300,});
        }
      });
      
      this.loadingCounter--
    },
  }
}
</script>
  